var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0C2.01489 0 0 2.01562 0 4.5C0 6.98583 2.01489 9 4.5 9C6.98511 9 9 6.98583 9 4.5C9 2.01562 6.98511 0 4.5 0ZM4.5 1.99597C4.9209 1.99597 5.2621 2.33717 5.2621 2.75806C5.2621 3.17896 4.9209 3.52016 4.5 3.52016C4.0791 3.52016 3.7379 3.17896 3.7379 2.75806C3.7379 2.33717 4.0791 1.99597 4.5 1.99597ZM5.51613 6.60484C5.51613 6.72509 5.41863 6.82258 5.29839 6.82258H3.70161C3.58136 6.82258 3.48387 6.72509 3.48387 6.60484V6.16935C3.48387 6.04911 3.58136 5.95161 3.70161 5.95161H3.91935V4.79032H3.70161C3.58136 4.79032 3.48387 4.69283 3.48387 4.57258V4.1371C3.48387 4.01685 3.58136 3.91935 3.70161 3.91935H4.8629C4.98315 3.91935 5.08065 4.01685 5.08065 4.1371V5.95161H5.29839C5.41863 5.95161 5.51613 6.04911 5.51613 6.16935V6.60484Z",
    fill: "url(#paint0_linear_773_10165)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_10165",
    x1: 4.5,
    y1: 0,
    x2: 4.5,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D34040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#981F1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.c92f434a110b70eca435779ab0556e89.svg";
export { ForwardRef as ReactComponent };